export default __webpack_public_path__ + "static/media/Grupo6140.b142358c.svg";